import { takeLatest, put } from "redux-saga/effects";

import { SAVE_DATA_BOOKING_REQUEST } from "./constants";
import { saveDataBookingSuccess } from "./actions";

import * as Api from '../../../services';


function* saveBooking(data) {
  try {

    const {
      room,
      billAddress,
	  billToName,
	  billToNameKana,
      billPostNumber,
      billPhoneNumber,
      email,
	  reservationName,
	  reservationNameKana,
      options,
      phoneNumber,
      ReservationDateId,
      date,
      conman,
      lockVersion,
    } = data.payload;

    let response;

    const _bookingNumber = localStorage.getItem('_bookingNumber');

    if (_bookingNumber) {

      // Update booking
      const updateData: any = {
        lockVersion: {
          content: lockVersion
        },
        reservationDateId: {
          content: ReservationDateId
        },
        remarks: {
          content: conman
        }
      };
      response = yield Api.updateBookingData(updateData);
      const { isSuccess } = response.data;
      yield put(saveDataBookingSuccess({
        bookingNumber: _bookingNumber,
        error: !isSuccess
      }));
    } else {

      // Create booking
      const postData: any = {
	      reservationName,
	      reservationNameKana,
        phoneNumber,
        email,
        reservationDateId: ReservationDateId,
        reservationDate: date,
        roomId: room,
        remarks: conman,
      };
      const ownerLocal =  localStorage.getItem('Owner');
      if(ownerLocal === 'checked') {
        if (options && options.length) {
          postData.workOption = {
            ids: options.map(a => a.id),
            billPostNumber: billPostNumber.replace('-', ''),
            billAddress,
            billToName,
            billToNameKana,
            billPhoneNumber
          };
        }
      }

      response = yield Api.saveBookingData(postData);
      const { data, isSuccess } = response.data;
      yield put(saveDataBookingSuccess({
        bookingNumber: data,
        error: !isSuccess
      }));
    }
  } catch (e) {
    return e;
  }
}

export function* saga() {
  yield takeLatest(SAVE_DATA_BOOKING_REQUEST, saveBooking);
}
